import { AxiosInstance } from "axios";
import { notification } from "antd";

export class ApiService {
  protected restClient: AxiosInstance;
  private urlApi;
  constructor(restClient: AxiosInstance, api: string = "") {
    this.urlApi = api; // Portal API ROOT path
    this.restClient = restClient;
  }

  public async GET(url, responseType = null) {
    try {
      const response = (
        await this.restClient.get(this.urlApi + url, {
          responseType: responseType ? responseType : "json"
        })
      ).data;
      return response;
    } catch (error) {
      return this.handleError(error, "");
    }
  }

  public async FETCH(url, setHook, setLoading, responseType = null) {
    setLoading(true);
    try {
      const response = (
        await this.restClient.get(this.urlApi + url, {
          responseType: responseType ? responseType : "json"
        })
      ).data;
      setHook(response);
    } catch (error) {
      return this.handleError(error, "");
    } finally {
      setLoading(false);
    }
  }

  public async POST(url, body) {
    try {
      const response = (await this.restClient.post(this.urlApi + url, body)).data;
      return response;
    } catch (error) {
      return this.handleError(error, "");
    }
  }

  public async PUT(url, body, responseType = null) {
    try {
      const response = (
        await this.restClient.put(this.urlApi + url, body, {
          responseType: responseType ? responseType : "json"
        })
      ).data;
      return response;
    } catch (error) {
      return this.handleError(error, "");
    }
  }

  public async DELETE(url, body?) {
    try {
      const response = await this.restClient.delete(this.urlApi + url, body);
      return response;
    } catch (error) {
      return this.handleError(error, "");
    }
  }

  private handleError(error, errorMessage) {
    if (errorMessage) {
      notification.error({
        message: errorMessage.Message,
        description: errorMessage.Description
      });

      throw error;
    }
    notification.error({
      message: "Falha na consulta",
      description: "Ocorreu um erro durante a consulta. Tente novamente."
    });
    throw error;
  }
}



// WEBPACK FOOTER //
// ./src/services/model/Api.model.ts